import { GUID } from '../../../helpers/guid.helper';

export class RelativeMedicalLetterDto {
    Id: string;
    FirstName: string;
    LastName: string;
    DocumentNumber: string;
    Birthdate: Date;
    PersonGenderId: number;
    RelationshipId: number;

    constructor() {
        this.Id = GUID.newGuid();
        this.FirstName = '';
        this.LastName = '';
        this.DocumentNumber = '';
        this.PersonGenderId = -1;
        this.RelationshipId = -1;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/persons/dto/relative-medical-letter-dto.ts